'use client';

import React from 'react';

import { TasticProps } from '../types';
import {
  AlgoliaRecommendationProvider,
  TrendingItems,
} from 'components/commercetools-ui/organisms/product/product-recommendations';
import { useBadgeLoader } from 'helpers/utils/badgeLoader';
import { P2Badge } from 'components/commercetools-ui/organisms/product/product-list-algolia/types';
import useLocale from 'helpers/hooks/useLocale';

const AlgoliaTrendingProductTastic = ({ data }: TasticProps<any>) => {
  const { locale } = useLocale();
  if (!data?.isEnableTrending) return <></>;
  const p1BadgeData = data?.data?.dataSource?.p1BadgeData;
  const p2BadgeData = data?.data?.dataSource?.p2BadgeData;
  const p1Badges = useBadgeLoader(p1BadgeData?.productListingContent);
  const p2Badges = p2BadgeData?.productListingContent as P2Badge[];
  const queryParameters = data?.data?.dataSource?.searchQuery?.searchQueryAttribute?.[locale?.replace('-', '_')];
  return (
    <AlgoliaRecommendationProvider>
      <div>
        <TrendingItems
          title={data?.trendingTitle}
          p1BadgeData={p1Badges}
          p2BadgeData={p2Badges}
          queryParameters={queryParameters}
        />
      </div>
    </AlgoliaRecommendationProvider>
  );
};

export default AlgoliaTrendingProductTastic;
